import React, { useRef } from "react";
import "./Milestones.css";
import { motion, useScroll, useTransform } from "framer-motion";

const Milestones = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end end"],
  });
  
  const { scrollYProgress: completionProgress } = useScroll()
  console.log(completionProgress)

  const testY = useTransform(scrollYProgress, [0, 1], ["100%", "0%"]);
  const backgroundY = useTransform(scrollYProgress, [0, 1], ["-100%", "0%"]);
  console.log(ref)
  return (
    <section ref= {ref} className="flexColCenter milestoneContianer">      
      <motion.div  className="flexColCenter milestoneScrollContianer">
        <motion.h1 style={{ translateX: testY }} className="flexStart titleBox">
          1992-2003
        </motion.h1>
        <motion.div
          style={{ translateX: backgroundY }}
          className="flexCenter contentBox"
        >
          Logistic Service contracts with Embassies and UN agencies for logistic
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Milestones;
